function page(path) {
  return () =>
    import(/* webpackChunkName: '' */ `@/views/admin/${path}`).then(
      (m) => m.default || m
    );
}

export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    hidden: true,
    component: page("dashboard/Dashboard.vue"),
    meta: {
      title: "Dashboard",
      noCache: true,
    },
  },

  {
    path: "/orders",
    name: "Orders",
    hidden: true,
    component: page("orders/Orders.vue"),
    meta: {
      title: "Orders",
      noCache: true,
    },
  },
  {
    path: "/ordershistory",
    name: "OrdersHistory",
    hidden: true,
    component: page("ordershistory/OrdersHistory.vue"),
    meta: {
      title: "Orders History",
      noCache: true,
    },
  },
  {
    path: "/customers",
    name: "Customers",
    hidden: true,
    component: page("customers/Customers.vue"),
    meta: {
      title: "Customers",
      noCache: true,
    },
  },
  {
    path: "/customers/:id",
    name: "customer-detail",
    component: page("customers/CustomerDetail.vue"),
    props: true,
    meta: {
      title: "Customers",
      noCache: true,
    },
  },
  {
    path: "/qrcodes",
    name: "qrcodes",
    hidden: true,
    component: page("qr-code/QrCodes.vue"),
    meta: {
      title: "qrcodes",
      noCache: true,
    },
  },
  {
    path: "/menus",
    name: "Menus",
    hidden: true,
    component: page("menus/Menus.vue"),
    meta: {
      title: "Menus",
      noCache: true,
    },
  },
  {
    path: "/menu-management",
    name: "Menu Management",
    hidden: true,
    component: page("menus/MenuManagement.vue"),
    meta: {
      title: "Menu Management",
      noCache: true,
    },
  },
  {
    path: "/account",
    name: "ManageAcount",
    redirect: "/account/companies",
    meta: {
      title: "Manage Acount",
    },
    children: [
      {
        path: "companies",
        name: "Companies",
        component: page("account/Companies.vue"),
        meta: {
          title: "Companies",
          noCache: true,
        },
      },
      {
        path: "stores",
        name: "Stores",
        hidden: true,
        component: page("account/Stores.vue"),
        meta: {
          title: "Stores",
          noCache: true,
        },
      },
      {
        path: "layouts",
        name: "Layouts",
        hidden: true,
        component: page("account/Layouts.vue"),
        meta: {
          title: "Layouts",
          noCache: true,
        },
      },
      {
        path: "settings",
        name: "Settings",
        hidden: true,
        component: page("account/Settings.vue"),
        meta: {
          title: "Settings",
          noCache: true,
        },
      },
      {
        path: "campaign-manager",
        name: "CampaignManager",
        hidden: true,
        component: page("account/CampaignManager.vue"),
        meta: {
          title: "Campaign manager",
          noCache: true,
        },
        children: [
          {
            path: "campaign",
            name: "Campaign",
            component: page("account/Campaigns.vue"),
            meta: {
              title: "Campaign",
              noCache: true,
            },
          },
          {
            path: "promo",
            name: "Promo",
            component: page("account/Promotions.vue"),
            meta: {
              title: "Promo",
              noCache: true,
            },
          },
          {
            path: "automations",
            name: "Automations",
            component: page("account/Automations.vue"),
            meta: {
              title: "Automations",
              noCache: true,
            },
          },
          {
            path: "sms-marketing",
            name: "SMSMarketing",
            component: page("account/SmsMarketing.vue"),
            meta: {
              title: "SMS Marketing",
              noCache: true,
            },
          },
          {
            path: "text-to-buy",
            name: "TextToBuy",
            component: page("account/TextToBuy.vue"),
            meta: {
              title: "Text to buy",
              noCache: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/storedetails",
    name: "StoreDetails",
    hidden: true,
    component: page("store/StoreDetails.vue"),
    meta: {
      title: "Store Details",
      noCache: true,
    },
  },
  {
    path: "/marketing",
    name: "Marketing",
    hidden: true,
    component: page("marketing/Marketing.vue"),
    meta: {
      title: "Marketing",
      noCache: true,
    },
  },
  {
    path: "/refunds",
    name: "Refunds",
    hidden: true,
    component: page("refunds/Refunds.vue"),
    meta: {
      title: "Refunds",
      noCache: true,
    },
  },
];
